// Warning: be careful adding any additional JS here as it may risk regressions on new or legacy pages
import '../stylesheets/global.scss';

// Global vendor JS
/* eslint-disable import/no-extraneous-dependencies */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/modal';

import { bootstrapTooltips } from '../custom/helpers/bootstrap';

import '../custom/helpers/jquery.mousewheel';
import '../custom/helpers/jquery.jscrollpane.min';
import '../custom/helpers/jquery.responsiveheight';

// Custom JS
import playlistModal from '../custom/global/playlistModal';
import { accountDropdown, loginModal } from '../custom/global';
import initPlaylists from '../custom/playlists';
import initLoginSlider from '../custom/login-slider';

// Footer Newsletter Klaviyo Form (must be in global, not application pack,
// because application pack only loads when @pack is true)
import '../custom/global/klaviyo-form';
/* eslint-enable import/no-extraneous-dependencies */

accountDropdown();
loginModal();
playlistModal();
initPlaylists();
initLoginSlider();
bootstrapTooltips();
